"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyStore = void 0;
const service_1 = require("@devim-front/service");
/**
 * Ленивое хранилище. Ленивое хранилище может иметь лишь единственный экземпляр,
 * который может быть получен с помощью статических методов get, with и use.
 */
class LazyStore extends service_1.LazyService {
}
exports.LazyStore = LazyStore;
